import React from 'react';
import formatDate from '../../../../../frontend/components/components/utils/formatDate';

const OfferColumn = ({ userOffer }) => (
  <a key={userOffer.offer_id} target="_blank" href={`/influencers/offer/${userOffer.offer.id}`}>
    {userOffer.offer.title}
  </a>
)

const CompletedDateColumn = ({ userOffer }) => (
  formatDate(userOffer.completed_date)
)

const CorgisColumn = ({ userOffer }) => userOffer.total_corgis

export const DEFAULT_COLUMNS = [
  'offer',
  'completed_date',
  'corgis'
]

export default {
  OfferColumn,
  CompletedDateColumn,
  CorgisColumn
}
